export const musicExtras = [
  {
    id: "music_device",
    title: "Fully Loaded Tablets",
    image: {
      url: "Tablets.jpg",
      alt: "Music devices",
    },
    video: true,
    videoUrl: "https://www.youtube.com/embed/0askl0Zzv-E?si=UrzmFo38Az9KebPA",
    videoThumbnail: {
      url: "video-ph.jpeg",
      alt: "Video Thumbnail",
    },
    details:
      "<p>You will need an audio device per channel/transmitter. You can use your own or choose our fully loaded Tablets for a wide range of playlists and music</p>",
    options: [
      { value: 0, label: "Using our own device" },
      { value: 30, label: "1 - £30", maxChannels: 2 },
      { value: 60, label: "2 - £60", maxChannels: 2 },
      { value: 75, label: "3 - £75", maxChannels: 3 },
    ],
    optionsInput: "select",
  },
  {
    id: "apple_adaptor",
    title: "Apple Lightning Audio Adaptors",
    image: {
      url: "Apple Adaptor.jpg",
      alt: "Music devices",
    },
    video: null,
    videoThumbnail: {
      url: "video-ph.png",
      alt: "Video Thumbnail",
    },
    details:
      "<p>If you are using a newer iPhone you will require the lightning audio adaptor. We can hire these to you if required.</p>",
    options: [
      { value: 0, label: "No Apple Adaptors" },
      { value: 6, label: "1 - £6", maxChannels: 2 },
      { value: 12, label: "2 - £12", maxChannels: 2 },
      { value: 15, label: "Special offer 3 for £15", maxChannels: 3 },
    ],
    optionsInput: "select",
  },
  {
    id: "google_adaptor",
    title: "USB C Audio Adaptors",
    image: {
      url: "Google Adaptors.jpg",
      alt: "Music devices",
    },
    video: null,
    videoThumbnail: {
      url: "video-ph.png",
      alt: "Video Thumbnail",
    },
    details:
      "<p>If you are using a newer google or android phone you will require the USB-C audio adaptor. We can hire these to you if required.</p>",
    options: [
      { value: 0, label: "No Adaptors" },
      { value: 6, label: "1 - £6", maxChannels: 2 },
      { value: 12, label: "2 - £12", maxChannels: 2 },
      { value: 15, label: "Special offer 3 for £15", maxChannels: 3 },
    ],
    optionsInput: "select",
  },
];

export const partyExtras = [
  {
    id: "standard_lighting",
    title: "Standard Lighting Package",
    image: {
      url: "Standard Lighting.png",
      alt: "Standard Lighting Package",
    },
    video: false,
    videoThumbnail: {
      url: null,
      alt: null,
    },
    details:
      "<p>2x 5in1 LED Disco Lights + 1x Smoke Machine.</p><p>Add to the party atmosphere with this perfect party package. Our 5-in-1 disco lights offer colour, laser and strobe effects</p>",
    options: [{ value: 75, label: "£75" }],
    optionsInput: "button",
  },
  {
    id: "premium_lighting",
    title: "Premium Lighting Package",
    image: {
      url: "Premium Lighting.png",
      alt: "Premium Lighting Package",
    },
    video: false,
    videoThumbnail: {
      url: null,
      alt: null,
    },
    details:
      "<p>2x 5in1 LED Disco Lights + 2x LED Lasers + 1x Smoke Machine</p><p>In addition to the standard party lighting package, we include 2x LED Lasers with multiple effects to create that nightclub feel.</p>",
    options: [{ value: 120, label: "£120" }],
    optionsInput: "button",
  },
  {
    id: "led_par_lights",
    title: "LED Par Lights",
    image: {
      url: "LED Par Can.jpg",
      alt: "LED Par Lights",
    },
    video: false,
    videoThumbnail: {
      url: null,
      alt: null,
    },
    details:
      "<p>LED Par cans provide the perfect solution for simple atmospheric mood lighting in any colour.</p>",
    options: [{ value: 20, label: "" }],
    optionsInput: "number",
  },
  {
    id: "photo_booth",
    title: "Photobooth Hire",
    image: {
      url: "Photobooth.jpg",
      alt: "Photobooth add on",
    },
    video: false,
    videoThumbnail: {
      url: null,
      alt: null,
    },
    details:
      "<p>Elevate your event with our easy-to-use photobooth! Capture fun memories throughout the day and instantly download your photos straight to your phone. Want prints too? Add printed photos for just £45 per 50 prints.</p>",
    options: [{ value: 150, label: "£150" }],
    optionsInput: "button",
  },
  {
    id: "photo_booth_prints",
    title: "Photobooth Prints £45 per 50",
    image: {
      url: "Photobooth.jpg",
      alt: "Photobooth add on",
    },
    video: false,
    videoThumbnail: {
      url: null,
      alt: null,
    },
    details: "<p>Printed photos for just £45 per 50 prints.</p>",
    options: [{ value: 45, label: "" }],
    optionsInput: "number",
  },
  {
    id: "karaoke",
    title: "Karaoke Hire add on",
    image: {
      url: "KARAOKE.jpg",
      alt: "Karaoke Hire add on",
    },
    video: false,
    videoThumbnail: {
      url: null,
      alt: null,
    },
    details:
      "<p>Loaded with hundreds of songs, take your party to the next level including 2x pro microphones with our karaoke system. Can be used with either silent disco or our PA Speaker.</p>",
    options: [{ value: 150, label: "£150" }],
    optionsInput: "button",
  },
  {
    id: "pa_speakers",
    title: "PA Speaker Hire",
    image: {
      url: "PA Speaker - Single.jpg",
      alt: "PA Speaker Hire",
    },
    video: false,
    videoThumbnail: {
      url: null,
      alt: null,
    },
    details:
      "<p>Our PA Speaker are a great addition for hire. Allowing you to have out loud music in addition to your silent disco.</p>",
    options: [{ value: 95, label: "£95" }],
    optionsInput: "button",
  },
  {
    id: "transmitter",
    title: "Battery Powered Transmitter",
    image: {
      url: "Battery Transmitter.jpg",
      alt: "Battery Powered Transmitter",
    },
    video: false,
    videoThumbnail: {
      url: null,
      alt: null,
    },
    details:
      "<p>No mains power available? Our Battery Operated Transmitters are state of the art. With a 8-10 hour battery life and Bluetooth connectivity.</p>",
    options: [
      { value: 0, label: "No Transmitters" },
      { value: 25, label: "1 - £25" },
      { value: 50, label: "2 - £50" },
      { value: 60, label: "3 - £60" },
    ],
    optionsInput: "select",
  },
  {
    id: "charger_sets",
    title: "Charger Sets",
    image: {
      url: "Charger.jpg",
      alt: "Charger Sets",
    },
    video: false,
    videoThumbnail: {
      url: null,
      alt: null,
    },
    details:
      "<p>Using your headphones over 8 hours? Hire our charger sets with each set charging 16 headphones.<br />£12 Per Set </p>",
    options: [{ value: 12, label: "" }],
    optionsInput: "number",
  },
  {
    id: "glow_sticks",
    title: "100x Glow Sticks",
    image: {
      url: "GlowStick.jpg",
      alt: "100x Glow Sticks",
    },
    video: false,
    videoThumbnail: {
      url: null,
      alt: null,
    },
    details:
      "<p>100x Glow sticks for the ultimate LED Glow party. A great addition to any event.</p>",
    options: [
      { value: 0, label: "No Glow Sticks" },
      { value: 10, label: "1 pack - £10" },
      { value: 20, label: "2 packs - £20" },
      { value: 30, label: "3 packs - £30" },
      { value: 40, label: "4 packs - £40" },
      { value: 50, label: "5 packs - £50" },
    ],
    optionsInput: "select",
  },
];
